import { Typography } from 'antd'
import { type TitleProps as AntdTitleProps } from 'antd/lib/typography/Title'
import clsx from 'clsx'
import styles from './styles.module.scss'

const WEIGHT_OPTIONS = {
  400: styles.weight400,
  500: styles.weight500,
  600: styles.weight600,
}

interface TitleProps extends AntdTitleProps {
  weight?: 400 | 500 | 600
  noMargin?: boolean
  textAlign?: React.CSSProperties['textAlign']
}

export function Title({ weight = 600, noMargin, textAlign, className, ...props }: TitleProps) {
  return (
    <Typography.Title
      {...props}
      style={{ textAlign }}
      className={clsx(className, WEIGHT_OPTIONS[weight], { [styles.noMargin]: noMargin })}
    />
  )
}
